import { Route, BrowserRouter as Router, Routes, Outlet } from 'react-router-dom';

import Home from '../page/index';
import About from '../page/about';
import Exhibit from '../page/exhibit';
import ExhibitDetail from '../page/exhibit/detail';
import Scenes from '../page/scenes';
import ScenesDetail from '../page/scenes/detail';
import Category from '../page/category';
import Product from '../page/product';
import AboutVideos from '../page/about/videos';
import AboutWhyUs from '../page/about/whyUs';
import AboutHistory from '../page/about/history';
import AboutNews from '../page/about/news';
import Faq from '../page/faq';
import Promotion from '../page/promotion';
import Login from '../page/login';
import LoginLostPassword from '../page/login/lostPassword';
import Privacy from '../page/privacy';
import DataProtection from '../page/dataProtection';
import Cart from '../page/cart';
import Account from '../page/account';
import AccountMemberLevels from '../page/account/memberLevels';
import AccountApprove from '../page/account/approve';
import AboutShipping from '../page/aboutShipping';
import Loding from '../components/loding';
import { useDispatch, useSelector } from 'react-redux';
import { stateType } from '../store/reducer';
import { useEffect } from 'react';
import { createLoginSuccessAction } from '../store/actions';

export default function AppRouter() {
  let state = useSelector<stateType, stateType>((state) => state);

  useEffect(() => {
    handleSetToken()
  }, [])
  let dispatch = useDispatch();
  const handleSetToken = () => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(
        createLoginSuccessAction(
          'token',
          token
        )
      );
    }
  }

  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route
            path='/'
            element={<Outlet />}>
            <Route
              index
              element={<Home />}
            />
            <Route
              path='/exhibit'
              element={<Exhibit />}
            />
            <Route
              path='/exhibit/detail'
              element={<ExhibitDetail />}
            />
            <Route
              path='/scenes'
              element={<Scenes />}
            />
            <Route
              path='/scenes/detail'
              element={<ScenesDetail />}
            />
            <Route
              path='/category'
              element={<Category />}
            />
            <Route
              path='/product'
              element={<Product />}
            />
            <Route
              path='/about/videos'
              element={<AboutVideos />}
            />
            <Route
              path='/about/whyUs'
              element={<AboutWhyUs />}
            />
            <Route
              path='/about/history'
              element={<AboutHistory />}
            /> 
            <Route
              path='/about/news'
              element={<AboutNews />}
            /> 
            <Route
              path='/faq'
              element={<Faq />}
            /> 
            <Route
              path='/promotion'
              element={<Promotion />}
            />
            <Route
              path='/login'
              element={<Login />}
            />  
            <Route
              path='/login/lostPassword'
              element={<LoginLostPassword />}
            />
            <Route
              path='/privacy'
              element={<Privacy />}
            />
            <Route
              path='/dataProtection'
              element={<DataProtection />}
            />  
            <Route
              path='/cart'
              element={<Cart />}
            />  
            <Route
              path='/account'
              element={<Account />}
            />  
            <Route
              path='/account/accountMemberLevels'
              element={<AccountMemberLevels />}
            />  
            <Route
              path='/account/approve'
              element={<AccountApprove />}
            />  
            <Route
              path='/aboutShipping'
              element={<AboutShipping />}
            />
          </Route>  
        </Routes>
      </Router>
      {state.showLoding && <Loding></Loding>}
    </div>
  );
}
